import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
const WhatSetsUsApart = () => {
  const { ref, inView } = useInView({
    triggerOnce: false, // Ensures animation happens only once
    threshold: 0.1, // Start animation when 10% of the element is visible
  });
  return (
    <div className="bg-[#FDFBF4] py-16 px-6 md:px-20 flex flex-col md:flex-row items-start justify-between overflow-x-hidden w-full">
      <div
        className="max-w-[1280px] mx-auto flex md:flex-row flex-col items-start justify-between bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/map.png')" }}
      >
        {/* Left Section */}
        <div className="md:w-1/2 space-y-2">
         
          <h2 className="text-black small:text-3xl text-2xl md:text-4xl font-extrabold">
          What Sets Us Apart{" "}
          </h2>
          <div className="underline py-3">
            <img
              alt="underline"
              src={require("../../common/images/underline.png")}
              className=" w-[150px] h-[5px]"
            />
          </div>
          {/* <h3 className="text-gray-500  text-lg  font-medium">
          </h3> */}
          <h3 className="text-[#FFC400] text-lg md:text-2xl font-semibold">
          Why Work with Us

          </h3>
          <p className="text-gray-700 text-sm md:text-base leading-relaxed">
            Join a team that values innovation, collaboration, and growth. At
            Binary Ops, we empower our employees with opportunities to learn,
            thrive, and make a meaningful impact. Our supportive environment and
            forward-thinking approach ensure that you grow both professionally
            and personally.
          </p>
          {/* <button className="bg-secondary text-white px-10 py-3 rounded-md font-medium shadow-md hover:bg-blue-700 transition-all">
            Apply Now
          </button> */}
        </div>

        {/* Right Section */}
        <div className="md:w-1/2 flex justify-center mt-8 md:mt-0 relative">
      <motion.img
        ref={ref}
        src={require("../../common/images/new-job.png")}
        alt="Illustration"
        className="w-[80%] ml-auto"
        initial={{ opacity: 0, x: 100 }} // Start off-screen (right side)
        animate={inView ? { opacity: 1, x: 0 } : {}} // Move into view
        transition={{ duration: 1, ease: "easeOut" }} // Smooth transition
      />
    </div>
      </div>
    </div>
  );
};

export default WhatSetsUsApart;
